import React, { forwardRef } from 'react';
import { clsx } from 'clsx';

import RadioOff from '@strava/icons/ActionsRadioOffSmall';
import RadioOn from '@strava/icons/ActionsRadioOnSmall';
import { color as colors } from '@strava/ui-tokens/js';

import styles from './Radio.module.scss';

export type RadioProps = React.ComponentPropsWithoutRef<'input'> & {
  name: string;
  value: string;
  id?: string;
  color?: string;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      name,
      value,
      id,
      color = colors.colorCoreO3,
      checked = false,
      disabled = false,
      className,
      onChange,
      ...props
    },
    ref
  ) => {
    return (
      <span
        className={clsx(styles.radio, className)}
        role="radio"
        aria-checked={checked}
        tabIndex={0}
      >
        <input
          type="radio"
          id={id ?? name}
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          tabIndex={-1}
          ref={ref}
          {...props}
        />

        {checked ? (
          <RadioOn fill={color} />
        ) : (
          <RadioOff fill={colors.colorExtendedNeutralN2} />
        )}
      </span>
    );
  }
);
